import PropTypes from 'prop-types';
import React from 'react';

import Panel from 'react-bootstrap/lib/Panel';
import Button from 'react-bootstrap/lib/Button';
import Icon from 'components/Icon/Icon';

import styles from './CreativeAcceptedPitch.module.scss';

const CreativeAcceptedPitch = ({
  pitch,
  paid,
  sentFinalFiles,
  onSendFiles,
}) => (
  <Panel>
    <div className={`${styles.step} ${styles.complete}`}>
      <div className={styles.number}>1</div>
      <div className={styles.body}>
        <Icon icon="&#xe60c;" className={styles.tick} />
        Pitch accepted{' '}
        {pitch.deposit && pitch.deposit_paid_at ? ' and deposit received' : ''}
      </div>
    </div>
    <div
      className={`${styles.step} ${
        sentFinalFiles ? styles.complete : styles.inProgress
      }`}
    >
      <div className={styles.number}>2</div>
      <div>
        <div className={styles.body}>
          {sentFinalFiles && <Icon icon="&#xe60c;" className={styles.tick} />}
          Send project files
          {!sentFinalFiles && (
            <Button
              bsStyle="primary"
              bsSize="xs"
              onClick={onSendFiles}
              className={styles.sendButton}
            >
              send files
            </Button>
          )}
        </div>
        <div className={styles.infoBox}>
          <p>
            The{' '}
            <a
              href="https://link.twine.fm/underpinned"
              target="_blank"
              title="Underpinned.com"
              rel="noreferrer"
            >
              UnderPinned Virtual Office
            </a>{' '}
            is the dream platform for freelancers looking to handle their admin.{' '}
            <a
              href="https://link.twine.fm/underpinned"
              target="_blank"
              title="Underpinned.com"
              rel="noreferrer"
            >
              Start here
            </a>
            .
          </p>
          <p>Send draft files using the "send files" button</p>
        </div>
      </div>
    </div>
    {paid && (
      <div
        className={`${styles.step} ${
          sentFinalFiles && pitch.paid_at === '' ? styles.inProgress : ''
        } ${sentFinalFiles && pitch.paid_at !== '' ? styles.complete : ''}`}
      >
        <div className={styles.number}>3</div>
        <div className={styles.body}>
          {sentFinalFiles && pitch.paid_at !== '' && (
            <Icon icon="&#xe60c;" className={styles.tick} />
          )}
          Receive payment
        </div>
      </div>
    )}
    <div
      className={`${styles.step}  ${
        pitch.completed_at === '' &&
        sentFinalFiles &&
        (!paid || (paid && pitch.paid_at !== ''))
          ? styles.inProgress
          : ''
      } ${
        pitch.completed_at !== '' &&
        sentFinalFiles &&
        (!paid || (paid && pitch.paid_at !== ''))
          ? styles.complete
          : ''
      }`}
    >
      <div className={styles.number}>{paid ? '4' : '3'}</div>
      <div className={styles.body}>
        {pitch.completed_at !== '' && (
          <Icon icon="&#xe60c;" className={styles.tick} />
        )}
        Complete
      </div>
    </div>
  </Panel>
);

CreativeAcceptedPitch.propTypes = {
  pitch: PropTypes.object,
  paid: PropTypes.bool,
  sentFinalFiles: PropTypes.bool,
  onSendFiles: PropTypes.func,
};

export default CreativeAcceptedPitch;
